import ExternalServicesReducer from 'store/external-services/reducers';

export default ExternalServicesReducer;
